import React from 'react';
import {
    TextField, Typography, MenuItem, FormGroup, Switch, FormControlLabel, Button,
    FormHelperText, Container, Select, InputLabel, Tabs, Tab
} from '@material-ui/core';
import { Alert, AlertTitle } from '@material-ui/lab';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from "react-router-dom";
import { SquadManagement } from './squad-management';
import { createLeague, updateLeague, getLeague, getTournaments } from '../../data';

const useStyles = (theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        padding: theme.spacing(5),
        alignItems: 'start',
    },
    header: {
        'flex-basis': '100%'
    },
    textField: {
        marginRight: theme.spacing(1),
        width: '25ch',
        marginTop: theme.spacing(2),
    },
    label: {
        marginTop: theme.spacing(2),
        marginRight: theme.spacing(2),
    },
    tournament: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
    },
    waiverText: {
        marginTop: theme.spacing(1),
    },
    button: {
        marginTop: theme.spacing(4),
        marginLeft: theme.spacing(4),
    },
    tabContent: {
        width: 400,
        paddingLeft: theme.spacing(2),
    }
});

const NUMERIC_FIELDS = [
    'squadMinSize',
    'squadMaxSize',
    'teamMinBatsman',
    'teamMinBowler',
    'teamMinKeeper',
    'squadMaxOverseas',
    'teamSize',
    'playerRepeat',
];

const validValues = {
    'name': (val) => val !== null && val !== undefined && val !== '' && val.trim().length > 0,
    'squadMinSize': (val) => val >= 6 && val <= 25,
    'squadMaxSize': (val) => val >= 6 && val <= 25,
    'teamMinBatsman': (val) => val > 0 && val <= 25,
    'teamMinBowler': (val) => val > 0 && val <= 25,
    'teamMinKeeper': (val) => val >= 0 && val <= 25,
    'squadMaxOverseas': (val) => val >= 0 && val <= 25,
    'teamSize': (val) => val >= 6 && val <= 25,
    'scoringTill': (val) => ['league', 'finals'].includes(val),
    'playerRepeat': (val) => val >= 0 && val <= 5,
    'draftType': (val) => val !== undefined && val !== null && val !== "",
    'tournament': (val) => val !== undefined && val !== null && val !== "",
    'maxCaptains': (val) => val >= 0 && val <= 100,
};

const DEFAULT_LEAGUE = {
    'name': '',
    'tournament': undefined,
    'squadMinSize': 11,
    'squadMaxSize': 11,
    'squadMaxOverseas': 4,
    'waivers': false,
    'teamSize': 11,
    'teamMinBatsman': 4,
    'teamMinBowler': 4,
    'teamMinKeeper': 0,
    'draftType': undefined,
    'auctionBag': 100,
    'playerRepeat': 0,
}

class CreateLeagueInternal extends React.Component {
    constructor(props) {
        super(props);
        var league = props.league;
        var isCreate = false;
        if (league === null || league === undefined) {
            league = DEFAULT_LEAGUE;
            isCreate = true;
        }
        this.isCreate = isCreate;
        this.state = {
            leagueType: '',
            error: {},
            serverError: undefined,
            tabIndex: 0,
            league: league,
            tournaments: [],
        };
        this.submitForm = this.submitForm.bind(this);
        this.onChangeType = this.onChangeType.bind(this);
        this.cancelCreate = this.cancelCreate.bind(this);
        this.goBack = this.goBack.bind(this);
        this.goNext = this.goNext.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.onFormChange = this.onFormChange.bind(this);
        this.refresh = this.refresh.bind(this);
    }

    async componentDidMount() {
        try {
            const tournaments = await getTournaments();
            this.setState({ tournaments });
        } catch (err) {
            console.error('Failed to load tournaments', err);
        }
    }

    onChangeType(event) {
        var self = this;
        self.setState(() => ({
            ...self.state,
            leagueType: event.target.value,
        }));
    }

    validate(self) {
        const f = document.querySelector('#create-league');
        const form = self.state.league;
        var error = {};
        var hasError = false;
        console.log(form);
        Object.keys(form).map(key => {
            if (validValues[key]) {
                const val = NUMERIC_FIELDS.includes(key) ? parseInt(form[key]) : form[key];
                error[key] = !validValues[key](val);
                if (!hasError) {
                    hasError = !validValues[key](val);
                }
            }
            return key;
        })
        self.setState(() => ({
            ...self.state,
            error: error,
        }));
        return hasError;
    }

    onFormChange = (event) => {
        var self = this;
        var league = self.state.league;
        league[event.target.name] = event.target.value || event.target.checked;
        self.setState(() => ({
            ...self.state,
            league: league,
        }));
    }

    async submitForm(event) {
        event.preventDefault();
        var self = this;
        const currentState = {
            ...self.state
        };
        currentState['serverError'] = undefined;
        self.setState(() => (currentState));
        var hasError = this.validate(self);
        if (!hasError) {
            // Submit league creation
            try {
                let data;
                if (this.isCreate) {
                    data = await createLeague(self.state.league);
                } else {
                    data = await updateLeague(self.state.league);
                }
                if (data) {
                    if (this.isCreate) {
                        self.props.history.push(data.url);
                    } else {
                        self.setState(() => ({
                            ...self.state,
                            success: true,
                        }));
                        setTimeout(() => {
                            self.setState(() => ({
                                ...self.state,
                                success: false,
                            }));
                        }, 3000);
                    }
                } else {
                    const error = 'Oops something went wrong!'
                    self.setState(() => ({
                        ...self.state,
                        serverError: error
                    }));
                }
            } catch (err) {
                self.setState(() => ({
                    ...self.state,
                    serverError: err.message
                }));
            }
        }
    }

    cancelCreate() {
        if (this.props.history.length > 0) {
            this.props.history.goBack();
        } else {
            this.props.historyy.push('/');
        }
    }

    goBack() {
        var self = this;
        var hasError = this.validate(self);
        if (hasError) {
            return;
        }
        const tabIndex = Math.max(0, self.state.tabIndex - 1);
        self.setState(() => ({
            ...self.state,
            tabIndex: tabIndex,
        }));
    }

    goNext() {
        var self = this;
        var hasError = this.validate(self);
        if (hasError) {
            return;
        }
        const tabIndex = Math.min(4, self.state.tabIndex + 1);
        self.setState(() => ({
            ...self.state,
            tabIndex: tabIndex,
        }));
    }

    handleTabChange(event, newTabIndex) {
        var self = this;
        var hasError = this.validate(self);
        if (hasError) {
            return;
        }
        this.setState(() => ({
            ...this.state,
            tabIndex: newTabIndex,
        }));
    }

    getTournamentOptions() {
        const allTournaments = this.state.tournaments || [];
        if (this.isCreate) {
            return allTournaments.filter(t => t.isActive);
        }
        // When editing, show active tournaments plus the league's stored tournament
        const options = allTournaments.filter(t => t.isActive);
        const currentTournament = this.state.league.tournament;
        if (currentTournament && !options.find(t => t.key === currentTournament)) {
            const existing = allTournaments.find(t => t.key === currentTournament);
            options.push(existing || { key: currentTournament, label: currentTournament });
        }
        return options;
    }

    stepOne(classes) {
        return (<div>
            <FormGroup row>
                <TextField required className={classes.textField} name='name' defaultValue={this.state.league.name} label="League Name" error={this.state.error.name} onChange={(e) => this.onFormChange(e)} />
            </FormGroup>
            <FormGroup row className={classes.textField}>
                <InputLabel id="tournament-select" className={classes.label}>Tournament</InputLabel>
                <Select name='tournament' labelId="tournament-select" id="tournament-select-value" className={classes.tournament}
                    value={this.state.league.tournament} onChange={(e) => this.onFormChange(e)} error={this.state.error.tournament}>
                    {this.getTournamentOptions().map(t => (
                        <MenuItem key={t.key} value={t.key}>{t.label}</MenuItem>
                    ))}
                </Select>
            </FormGroup>
            <FormGroup row>
                <InputLabel id="draft-type" className={classes.label}>Draft Type</InputLabel>
                <Select name='draftType' labelId="draft-type" id="draft-type-value" className={classes.tournament} onChange={(e) => this.onFormChange(e)} value={this.state.league.draftType} error={this.state.error.draftType} >
                    <MenuItem value={'snake'}>SNAKE</MenuItem>
                    <MenuItem value={'auction'}>AUCTION</MenuItem>
                </Select>
            </FormGroup>
            <FormGroup row>
                {(this.state.league.draftType === "auction") &&
                    <TextField className={classes.textField} name="auctionBag" label="Auction Bag" type="number" required onChange={(e) => this.onFormChange(e)} value={this.state.league.auctionBag} error={this.state.error.auctionBag} />
                }
            </FormGroup>
            <FormGroup row>
                <TextField className={classes.textField} name="playerRepeat" label="Player repeat" type="number"
                    disabled={this.state.leagueType === 'auction'} defaultValue={this.state.league.playerRepeat}
                    helperText='Number of teams a player can be in simultaneously. 1 indicates a player can only be on a single squad. Use 0 for no limits.'
                    error={this.state.error.playerRepeat} onChange={(e) => this.onFormChange(e)} />
            </FormGroup>
            {!this.isCreate && <FormGroup row>
                <InputLabel id="status-select" className={classes.label}>Status</InputLabel>
                <Select name="status" value={this.state.league.status} onChange={(e) => this.onFormChange(e)}>
                    <MenuItem value={'predraft'}>PREDRAFT</MenuItem>
                    <MenuItem value={'drafting'}>DRAFTING</MenuItem>
                    <MenuItem value={'playing'}>PLAYING</MenuItem>
                </Select>
            </FormGroup>}
        </div>)
    }

    stepTwo(classes) {
        return (
            <div>
                <FormGroup row>
                    <TextField className={classes.textField} name="squadMinSize" label="Minimum Squad size" type="number" defaultValue={this.state.league.squadMinSize} required error={this.state.error.squadMinSize} onChange={(e) => this.onFormChange(e)} />
                </FormGroup>
                <FormGroup row>
                    <TextField className={classes.textField} name="squadMaxSize" label="Maximum Squad size" type="number" defaultValue={this.state.league.squadMaxSize} required error={this.state.error.squadMaxSize} onChange={(e) => this.onFormChange(e)} />
                </FormGroup>
                <FormGroup row>
                    <TextField className={classes.textField} name="squadMaxOverseas" label="Maximum overseas players in squad" type="number" defaultValue={this.state.league.squadMaxOverseas} error={this.state.error.squadMaxOverseas} onChange={(e) => this.onFormChange(e)} />
                </FormGroup>
                <FormGroup row>
                    <TextField className={classes.textField} name="maxCaptains" label="Maximum number of captains" type="number" defaultValue={this.state.league.maxCaptains} error={this.state.error.maxCaptains} onChange={(e) => this.onFormChange(e)} />
                </FormGroup>
                <FormGroup row>
                    <FormControlLabel control={<Switch checked={this.state.league.waivers} />} label="Waivers enabled?" name='waivers' onChange={(e) => this.onFormChange(e)} />
                    <FormHelperText className={classes.waiverText}>Enables squad substitutions between gameweeks.</FormHelperText>
                </FormGroup>
            </div>
        )
    }

    stepThree(classes) {
        return (
            <div>
                <FormGroup row>
                    <TextField className={classes.textField} name="teamSize" label="Team size" type="number" defaultValue={this.state.league.teamSize} required error={this.state.error.teamSize} onChange={(e) => this.onFormChange(e)} />
                </FormGroup>
                <FormGroup row>
                    <TextField className={classes.textField} name="teamMinBatsman" label="Minimum batsmen in team" type="number" defaultValue={this.state.league.teamMinBatsman} error={this.state.error.teamMinBatsman} onChange={(e) => this.onFormChange(e)} />
                </FormGroup>
                <FormGroup row>
                    <TextField className={classes.textField} name="teamMinBowler" label="Minimum bowlers in team" type="number" defaultValue={this.state.league.teamMinBowler} error={this.state.error.teamMinBowler} onChange={(e) => this.onFormChange(e)} />
                </FormGroup>
                <FormGroup row>
                    <TextField className={classes.textField} name="teamMinKeeper" label="Minimum WK in team" type="number" defaultValue={this.state.league.teamMinKeeper} error={this.state.error.teamMinKeeper} onChange={(e) => this.onFormChange(e)} />
                </FormGroup>
            </div>
        )
    }

    async refresh() {
        try {
            const league = await getLeague(this.state.league.leagueID);
            this.setState(() => ({
                ...this.state,
                loading: false,
                league: league,
            }));
        } catch (err) {
            this.setState(() => ({
                ...this.state,
                loading: false,
                serverError: err.message,
            }));
        }
    }

    stepFour(classess) {
        return (<SquadManagement league={this.state.league} refresh={this.refresh} />);
    }

    render() {
        const { classes } = this.props;
        var serverError;
        if (this.state.serverError !== undefined) {
            serverError = (
                <div style={{ flexBasis: '100%', alignSelf: 'start', textAlign: 'left' }}>
                    <Alert severity="error">
                        <AlertTitle>Server Error</AlertTitle>
                        {this.state.serverError}
                    </Alert>
                </div>
            )
        }
        return (
            <Container className={classes.root}>
                {this.isCreate &&
                    <Typography variant="h5" className={classes.header}>
                        Create League
                    </Typography>}
                {serverError}
                {this.state.success &&
                    <div style={{ flexBasis: '100%', alignSelf: 'start', textAlign: 'left', marginTop: 5 }}>
                        <Alert severity="success">
                            <AlertTitle>League updated!</AlertTitle>
                            {serverError}
                        </Alert>
                    </div>
                }
                <Tabs value={this.state.tabIndex} onChange={this.handleTabChange} style={{ marginBottom: 30, selfAlign: 'center' }} orientation='vertical'>
                    <Tab label="Overall" />
                    <Tab label="Squad" />
                    <Tab label="Team" />
                    {!this.isCreate && <Tab label="Invites" />}
                </Tabs>
                <form autoComplete="off" id='create-league' onSubmit={(e) => this.submitForm(e)}>
                    <div className={classes.tabContent}>
                        {this.state.tabIndex == 0 && this.stepOne(classes)}
                        {this.state.tabIndex == 1 && this.stepTwo(classes)}
                        {this.state.tabIndex == 2 && this.stepThree(classes)}
                        {this.state.tabIndex == 3 && !this.isCreate && this.stepFour(classes)}
                        {!this.isCreate && this.state.tabIndex != 3 && <FormGroup row>
                            <Button className={classes.button} variant="contained" color="secondary" onClick={(e) => this.cancelCreate()}>Cancel</Button>
                            <Button className={classes.button} variant="contained" color="primary" type='submit'>Save</Button>
                        </FormGroup>}
                        {this.isCreate && this.state.tabIndex == 2 && <FormGroup row>
                            <Button className={classes.button} variant="contained" color="secondary" onClick={(e) => this.cancelCreate()}>Cancel</Button>
                            <Button className={classes.button} variant="contained" color="primary" type='submit'>{'Create league'}</Button>&nbsp;&nbsp;
                        </FormGroup>}
                    </div>
                </form>
            </Container>
        );
    }
}

export const CreateLeague = withRouter(withStyles(useStyles)(CreateLeagueInternal));